/* Paola & Joy — collection quick add.
   Single-variant pieces add straight to the bag; anything with a choice to
   make sends you to the product page rather than guessing a variant. */
(function () {
  /* ------------------------------------------------------------------------
     On the cart page the recently-viewed row sits below the bag itself, so an
     add has to re-render the bag. Without this the quantity and totals on
     screen stay as they were — measured going to 2 x $229 in the cart while
     the table still read 1 and $229 — and it looks as though the button did
     nothing. Re-renders through the Section Rendering API, falling back to a
     plain reload if that fails.
     ---------------------------------------------------------------------- */
  function refreshCartSections() {
    var ids = [].slice.call(document.querySelectorAll('[id^="shopify-section-"]'))
      .map(function (el) { return el.id.replace('shopify-section-', ''); })
      .filter(function (id) { return id.indexOf('__cart-') > -1; });
    if (!ids.length) { window.location.reload(); return; }

    fetch(window.Shopify.routes.root + 'cart?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        ids.forEach(function (id) {
          var host = document.getElementById('shopify-section-' + id);
          if (!host || !data[id]) return;
          var doc = new DOMParser().parseFromString(data[id], 'text/html');
          var fresh = doc.getElementById('shopify-section-' + id);
          host.innerHTML = fresh ? fresh.innerHTML : data[id];
        });
      })
      .catch(function () { window.location.reload(); });
  }

  function init(btn) {
    if (btn.dataset.pjQuickaddReady === 'true') return;
    btn.dataset.pjQuickaddReady = 'true';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (btn.dataset.single !== 'true') {
        window.location.href = btn.dataset.url;
        return;
      }

      btn.disabled = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (window.PJToast) window.PJToast.show(res.body.description || 'That one is unavailable.', { hideBag: true });
            return;
          }
          if (window.PJToast) {
            window.PJToast.show('Added to your bag — ' + btn.dataset.title);
            window.PJToast.refreshCartCount();
          }
          if (document.body.classList.contains('template--cart')) refreshCartSections();
          /* Hold the confirmed state for two seconds, then revert. */
          btn.classList.add('is-added');
          var label = btn.querySelector('.pj-tile__add-label');
          if (label && btn.dataset.addedLabel) label.textContent = btn.dataset.addedLabel;
          setTimeout(function () {
            btn.classList.remove('is-added');
            if (label && btn.dataset.idleLabel) label.textContent = btn.dataset.idleLabel;
          }, 2000);
        })
        .catch(function () {
          if (window.PJToast) window.PJToast.show('Something went wrong. Please try again.', { hideBag: true });
        })
        .then(function () { btn.disabled = false; });
    });
  }

  function boot() { document.querySelectorAll('[data-pj-quickadd]').forEach(init); }

  /* ------------------------------------------------------------------------
     Load more — append, don't navigate.
     The link keeps a real href so pagination still works without JavaScript;
     here we intercept it, fetch the next page and move its tiles into the grid
     already on screen.
     ---------------------------------------------------------------------- */
  function initLoadMore() {
    var link = document.querySelector('[data-pj-load-more]');
    if (!link || link.dataset.ready === 'true') return;
    link.dataset.ready = 'true';

    link.addEventListener('click', function (e) {
      if (!window.fetch || !window.DOMParser) return; // let the href do its job
      e.preventDefault();

      var url = link.getAttribute('href');
      var idle = link.textContent;
      link.classList.add('is-loading');
      if (link.dataset.loadingLabel) link.textContent = link.dataset.loadingLabel;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          /* Append every tile from the next page into the last grid here. The
             in-situ editorial block lives outside .pj-col__grid, so it is
             never duplicated by this. */
          var grids = document.querySelectorAll('.pj-col__grid');
          var target = grids[grids.length - 1];
          var incoming = doc.querySelectorAll('.pj-col__grid > *');
          if (!target || !incoming.length) return;

          var frag = document.createDocumentFragment();
          incoming.forEach(function (node) { frag.appendChild(document.importNode(node, true)); });
          target.appendChild(frag);

          /* Keep the count honest. */
          var shownEl = document.querySelector('[data-pj-shown]');
          var nextShown = doc.querySelector('[data-pj-shown]');
          if (shownEl && nextShown) shownEl.textContent = nextShown.textContent;

          /* Point the link at the page after this one, or retire it. */
          var nextLink = doc.querySelector('[data-pj-load-more]');
          if (nextLink) {
            link.setAttribute('href', nextLink.getAttribute('href'));
            link.textContent = idle;
          } else {
            link.remove();
          }

          /* The URL stays on the collection root so a refresh starts over
             rather than stranding the shopper mid-way. */
          var back = document.querySelector('.pj-col__back');
          if (back) back.remove();

          boot(); // wire quick add on the tiles just added
        })
        .catch(function () {
          window.location.href = url; // fall back to ordinary pagination
        })
        .then(function () {
          link.classList.remove('is-loading');
        });
    });
  }

  /* Recently viewed renders its tiles from product JSON after this file has
     already booted, so it needs a way to wire the buttons it just created. */
  window.PJQuickAdd = { boot: boot, init: init };

  /* Hover video.

     CSS can fade a video in but cannot press play, so the hover reveal needs
     this much JS. Delegated from the document rather than bound per tile,
     because Load more and Recently viewed both inject tiles after boot.

     mouseover/mouseout fire again for every child element the cursor crosses,
     so each handler bails when the cursor merely moved WITHIN the same tile --
     otherwise the video would restart as the pointer passed over the quick-add
     bar. */
  /* Resolved from .pj-tile rather than .pj-tile__media for the same reason the
     CSS is: the cursor is almost always on the stretched .pj-tile__link, which
     sits outside the media box. */
  function hoverVideoFor(el) {
    var tile = el && el.closest ? el.closest('.pj-tile') : null;
    if (!tile) return null;
    return { media: tile, video: tile.querySelector('.pj-tile__hover video') };
  }

  function initHoverVideo() {
    if (window.pjTileHoverBound) return;
    window.pjTileHoverBound = true;

    document.addEventListener('mouseover', function (e) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var hit = hoverVideoFor(e.target);
      if (!hit || !hit.video) return;
      if (hit.media.contains(e.relatedTarget)) return; // already inside this tile
      hit.video.muted = true; // a non-muted play() is blocked without a gesture
      var p = hit.video.play();
      if (p && p.catch) p.catch(function () {});
    });

    document.addEventListener('mouseout', function (e) {
      var hit = hoverVideoFor(e.target);
      if (!hit || !hit.video) return;
      if (hit.media.contains(e.relatedTarget)) return; // still inside this tile
      hit.video.pause();
      try { hit.video.currentTime = 0; } catch (err) {}
    });
  }

  function start() { boot(); initLoadMore(); initHoverVideo(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
})();
